import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Desafios_Cursos_Estudiante_Grupo, Estudiantes, Grupos } from 'generated/graphql';

interface ListaEstudianteI {
	estudianteList: Estudiantes[] | [];
	grupoList: { nombre: string; key: string; integrantesGrupo: Desafios_Cursos_Estudiante_Grupo[] }[] | [];
	estudiantesConGrupo: Grupos | never[];
	cursoData: { nombre: string; key: string };
}

const initialState: ListaEstudianteI = {
	estudianteList: [],
	grupoList: [],
	estudiantesConGrupo: [],
	cursoData: { nombre: '', key: '' }
};

const listaStudentStateSlice = createSlice({
	name: 'listaStudentState',
	initialState,
	reducers: {
		setListaStudentState: (state, action: PayloadAction<ListaEstudianteI>) => {
			return action.payload;
		},
		updateListaStudentState: (state, action) => {
			return { ...state, ...action.payload };
		},
		resetListaStudentState: () => {
			return initialState;
		}
	}
});

export const { setListaStudentState, updateListaStudentState, resetListaStudentState } = listaStudentStateSlice.actions;

export default listaStudentStateSlice.reducer;
